
/* injects from baggage-loader */
require('./style.styl');

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'components/DatePicker'
import moment from 'moment'

export default class TimePeriodDashboard extends React.Component {
  static propTypes = {
    timePeriod: PropTypes.string,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func,
    timeRanges: PropTypes.object,
    dynamicDateType: PropTypes.string,
    today: PropTypes.instanceOf(Date),
    short: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      type: props.timePeriod
    }
  }

  render() {
    return <Fragment>{this.renderCustomRange()}</Fragment>
  }

  renderCustomRange() {
    const {disabled, today, timeRanges, short, dynamicDateType} = this.props
    const {type} = this.state
    if (!timeRanges) return null

    const modes = ['range', 'week', 'month', 'year']
    return (
      <div className='time-period-selector_custom-range'>
        <div className='time-period-selector_select-title'>Compare</div>
        <DatePicker
          className=''
          disabled={disabled}
          startDate={moment(timeRanges.start.start).clone().toDate()}
          endDate={moment(timeRanges.start.end).clone().toDate()}
          dynamicDateType={dynamicDateType}
          onChangeModes={this.onChangeModes}
          type={type}
          modes={modes}
          today={moment(today).clone().toDate()}
          onSelect={this.selectGlobalDateRange}
        />
        <div className='time-period-selector_select-title is-second'>with</div>
        <DatePicker
          className=''
          disabled
          startDate={moment(timeRanges.end.start).clone().toDate()}
          endDate={moment(timeRanges.end.end).clone().toDate()}
          type={type}
          modes={modes}
          today={moment(today).clone().toDate()}
          onSelect={this.selectGlobalDateRange}
        />
      </div>
    )
  }

  onTimePeriodSelect = item => {
    const {onSelect, timeRanges} = this.props
    const {startRange: start, endRange: end} = timeRanges

    onSelect(item.value, start, end)
  };

  onStartYearSelect = item => {
    const year = moment([item.value])
    this.onSelectStartRange(year.startOf('year'), year.endOf('year'))
  };

  onEndYearSelect = item => {
    const year = moment([item.value])
    this.onSelectEndRange(year.startOf('year'), year.endOf('year'))
  };

  onSelectStartRange = (start, end) => {
    const {onSelect, timePeriod, timeRanges} = this.props
    const {end: endRange} = timeRanges
    const startRange = {start, end}

    onSelect(timePeriod, startRange, endRange)
  };

  onSelectEndRange = (start, end) => {
    const {onSelect, timePeriod, timeRanges} = this.props
    const {start: startRange} = timeRanges
    const endRange = {start, end}

    onSelect(timePeriod, startRange, endRange)
  };
  onChangeModes = type => {
    this.setState({
      type
    })
  };

  getMaxDate() {
    const {today, timePeriod} = this.props

    switch (timePeriod) {
      case 'week':
        return moment(today).subtract(1, 'week').startOf('isoWeek')
      case 'month':
        return moment(today).startOf('month')
    }
  }
  selectGlobalDateRange = (
    startDate,
    endDate,
    dynamicDateType = false,
    range
  ) => {
    const {type} = this.state
    const {onSelect} = this.props
    let newStartDate = moment(startDate).toDate()
    let newEndDate = moment(endDate).toDate()
    if (dynamicDateType) {
      localStorage.setItem('dynamicDateType', dynamicDateType)
    } else {
      localStorage.removeItem('dynamicDateType')
    }
    const typeRange =
      type === 'month' ? 'months' : type === 'year' ? 'years' : 'days'
    const dayDiff = moment(moment(newEndDate).format()).diff(
      moment(newStartDate).format(),
      typeRange
    )
    const startRange = {
      start: newStartDate,
      end: newEndDate
    }
    const endDayStart = moment(newStartDate)
      .subtract(1 + dayDiff, typeRange)
      .toDate()
    const endDayEnd = moment(newStartDate)
      .endOf('day')
      .subtract(1, typeRange)
      .endOf(typeRange)
      .toDate()
    const endRange = {start: endDayStart, end: endDayEnd}
    onSelect(type, startRange, endRange, dynamicDateType)
  };
}



// WEBPACK FOOTER //
// ./client/components/TimePeriodDashboard/index.js